import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'

import { IconName } from 'app/core/icons.const'
import { LoggerService } from 'app/core/logger/logger.service'

import { BaseSvgComponent } from './base-svg.component'

/**
 * component to display one of the registered svg icons inline.
 *   The SVG content is directly inlined as a child of the <pai-icon> component,
 *   therefore CSS styles can be easily applied.
 * @example
 *   <pai-icon icon="chevron-right" />
 * todo: change selector to `svg[icon]` and adapt as needed
 */
@Component({
  selector: 'pai-icon',
  template: '',
  standalone: true,
  styles: `
    :host {
      display: flex;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent extends BaseSvgComponent {
  readonly icon = input.required<IconName>()

  protected readonly logger = inject(LoggerService).getInstance('IconComponent')

  protected urlAndAttrs = computed(() => ({ url: `/assets/icons/${this.icon()}.svg` }))
}
